<template>
  <div class="member-details">
    <div class="loading" v-if="memberData === null && responseState === null"></div> 
    <div class="error" v-if="responseState !== null && responseState.num !== 200">{{responseState.num}}</div> 
    <div class="container" v-if="memberData !== null">  
      <div class="details-outer">  
        <div class="details-left">  
          <div class="details-box details-box-with-image">  
            <div class="details-box-image-area">  
              <img class="" :src="memberData.memberImage" @error="onImageError"/>
            </div>
            <div class="details-box-text-area">  
              <h1>{{memberData.firstname}} {{memberData.lastname}}</h1>
              <p>MAP {{$route.params.map}}</p>
              <!--p>{{memberData.birthday | moment('Do MMMM YYYY')}}</p-->
              <div class="details-box-country">
                <img class="details-flag" :src="flagsPath + memberData.country_image"/>
                &nbsp;
                <span>{{memberData.country_name}}</span>
              </div>
              <div class="details-box-dojo">
                <img :src="logoPath + memberData.dojo_id + '.jpg'" @error="onLogoImageError">
                <p>{{memberData.dojo}}</p>
              </div> 
              <div class="details-box-belt">
                <img :src="beltsPath + memberData.belt_img"/>
              </div>
            </div>
          </div>
          <div class="details-box" v-if="memberData.rules_committee === '1'">  
            <h2>Organization Licenses</h2>
            <div class="skill-line" v-if="memberData.rules_committee === '1'">
              <span class="skill-star skill-star-rules" >★</span> Rules Committee Member
            </div>
          </div>
          <div class="details-box" v-if="(memberData.referee_national_id > 0 && memberData.referee_national_id <= 5) || (memberData.referee_international_id > 0 && memberData.referee_international_id <= 5)">  
            <h2>Referee Licenses</h2>
            <div class="skill-line" v-if="memberData.referee_national_id > 0 && memberData.referee_national_id <= 5">
              <span class="skill-star skill-star-referee national" v-for="n in memberData.referee_national_id * 1" :key="n">★</span> National {{memberData.national_referee}}
            </div>
            <div class="skill-line" v-if="memberData.referee_international_id > 0 && memberData.referee_international_id <= 5">
              <span class="skill-star skill-star-referee international" v-for="n in memberData.referee_international_id * 1" :key="n">★</span> International {{memberData.national_referee}}
            </div>
          </div>
          <div class="details-box" v-if="memberData.coachSkills.length > 0">  
            <h2>Coach Licenses</h2>
            <div class="skill-line" v-for="(coachSkill, index) in memberData.coachSkills" :key="index">
              <span class="skill-star skill-star-coach">★</span> {{coachSkill.skill_name}}
            </div>
          </div>
        </div>
        
        <div class="details-right" v-if="memberData.achievements.fight.length === 0 && memberData.achievements.forms.length === 0"> 
          <div class="details-box">
            <p>No achievements registered.</p>
          </div>
        </div>

        <div class="details-right" v-if="memberData.achievements.fight.length > 0 || memberData.achievements.forms.length > 0"> 
        
          <div class="details-box">
            <h1>{{$t('message.achievements')}}</h1>
          </div>
          
          <div class="details-box" v-if="memberData.achievements.fight.length > 0">  
            <h2>Fight</h2>            
            <div class="details-list-outer" v-for="(category, index) in tournamentCategories" v-if="hasAchievements(memberData.achievements.fight, category)" :key="index">
              <h3>{{$t('message.category')}} {{category}} {{memberData.length}}</h3>            
              <div class="details-list">  
                <div class="details-list-line" v-for="(item, index) in memberData.achievements.fight" v-if="item.txt_short === category" :key="index">  
                  <div class="details-list-image-outer">
                    <img :src="gfxPath +'medals_wcs_gold.png'" v-if="item.ranking === '1'"/>
                    <img :src="gfxPath +'medals_wcs_silver.png'" v-if="item.ranking === '2'"/>
                    <img :src="gfxPath +'medals_wcs_bronze.png'" v-if="item.ranking === '3'"/>
                  </div>
                  <div class="details-list-caption-outer">
                    <div class="details-list-caption-top">
                      {{item.title}}
                    </div>
                    <div class="details-list-caption-bottom">
                      {{item.ranking}}. {{item.bez}} {{item.cat_name}} {{item.vz}}{{item.val}}{{item.unity}}
                    </div>
                  </div>
                  <div class="details-list-action-outer">  
                  </div>
                </div>
              </div>            
            </div>
          </div>          
          
          <div class="details-box" v-if="memberData.achievements.forms.length > 0">  
            <h2>Forms</h2>            
            <div class="details-list-outer" v-for="category in tournamentCategories" v-if="hasAchievements(memberData.achievements.forms, category)">
              <h3>Category {{category}} {{memberData.length}}</h3>            
              <div class="details-list">  
                <div class="details-list-line" v-for="item in memberData.achievements.forms" v-if="item.txt_short === category">  
                  <div class="details-list-image-outer">  
                    <img :src="gfxPath +'medals_wcs_gold.png'" v-if="item.ranking === '1'"/>
                    <img :src="gfxPath +'medals_wcs_silver.png'" v-if="item.ranking === '2'"/>
                    <img :src="gfxPath +'medals_wcs_bronze.png'" v-if="item.ranking === '3'"/>
                  </div>
                  <div class="details-list-caption-outer">
                    <div class="details-list-caption-top">
                      {{item.title}}
                    </div>
                    <div class="details-list-caption-bottom">
                      {{item.ranking}}. {{item.bez}} {{item.cat_name}} {{item.vz}}{{item.val}}{{item.unity}}
                    </div>
                  </div>
                  <div class="details-list-action-outer">  
                  </div>
                </div>
              </div>            
            </div>
          </div>
          
        </div>
        
      </div>
    </div>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'
import _ from 'lodash'

export default {
  name: 'memberDetails',
  data () {
    return {
      responseState: null,
      tournamentCategories: ['IA','IB', 'A', 'B', 'C', 'D']
    }
  },
  methods: {
    getMember: function (map) {
      this.$store.dispatch('members/getDetails', map).then(() => {
        // this.getRepresentatives()
      })
    },
    initSearchField: function () {
      this.searchText = ''
    },
    hasAchievements: function (items, category) {
      if (this.memberData === 0) return false
      if (_.some(items, ['txt_short', category])) {
        return true
      } else {
        return false
      }
    },
    onLogoImageError: function (event) {
      event.target.src = './dojo-dummy.png'
    },
    onImageError: function (event) {
      event.target.src = './person-dummy.png'
    }
  },
  computed: {
    ...mapGetters({
      memberData: 'members/details',
      logoPath: 'dojos/logoPath',
      flagsPath: 'countries/flagsPath',
      beltsPath: 'members/beltsPath',
      gfxPath: 'members/gfxPath'
    })
  },
  activated: function () {
    // `this` points to the vm instance
    console.log('url map is: ' + this.$route.params.map)
    this.getMember(this.$route.params.map)
  }
}
</script>
